<app-navbar></app-navbar>

<div class="relative w-screen min-h-screen bg-black">
  <!-- Video Background -->
  <video autoplay muted loop class="absolute top-0 left-0 w-full h-full object-cover">
    <source src="../../../../../assets/vid/hero-bg.mp4" type="video/mp4">
  </video>

  <!-- Overlay to Darken Video -->
  <div class="absolute inset-0 bg-black bg-opacity-50"></div>

  <!-- Content Section -->
  <div class="relative z-10 flex flex-col items-center justify-center min-h-screen text-white text-center px-6">
    <div class="max-w-4xl">
      <h1 class="text-2xl md:text-5xl font-bold leading-tight mb-10">مرحبا بك في قبيلة آل بازيد</h1>

      <p class="text-lg md:text-lg leading-relaxed mt-6">
        <strong>سكنهم:</strong> كانوا يسكنون في وادي دوعن وبلاد حريضة، وهم من بني سلمة بن عمرو، بطن من زيد بن معاوية
        الأكرمين من كندة.
      </p>

      <p class="text-lg md:text-lg leading-relaxed mt-6">
        <strong>نسبهم:</strong> يرجع نسبهم إلى عبدالله بن ياسين بن زيد بن وهب بن طه بن زيد بن حمد بن عبيد بن بدر بن زيد
        بن النعمان بن أبي زيد عمر بن عبدالله بن بريك بن سهل بن عدي بن كعب بن امرئ القيس بن عمرو بن شرحبيل بن الحارث بن
        قيس بن زيد بن سلمة بن عمرو بن مالك بن معاوية بن الحارث بن وهب بن زيد بن معاوية الأكرمين بن الحارث بن معاوية بن
        ثور بن مرتع بن كندة.
      </p>

      <p class="text-lg md:text-lg leading-relaxed mt-6">
        وقد ظهر من هذه العائلة قوم من خيار أهل العلم والصلاح، منهم الفقيه محسن بن بكر بن سعيد بن عبدالرحمن بن حمزة بن
        عبدالله بن ياسين بن زيد بن وهب بن طه بن بازيد الحضرمي الكندي، الذي توفي ببلد محروم في 18 جمادى الأولى سنة 889
        هجرية. كان من الفقهاء الصالحين العاملين، رحل إلى الرباط. ومن ولده عبدالله بن سلامة بن محمد بن الفقيه محسن بن بكر
        بازيد الحضرمي الكندي.
      </p>


      <p class="text-lg md:text-lg leading-relaxed mt-6">
        كما أنه يوجد في حضرموت جماعة آخرون في دوعن، يقال لهم آل بن زيد، غير آل بازيد، يرجع نسبهم إلى حمير الأكبر. وقوم
        آخرون يقال لهم آل زيد ويرجع نسبهم إلى مذحج.
      </p>
      <p (click)="openDialog = true" class=" mt-6 underline cursor-pointer">
        المرجع : كتاب درر الياقوت
      </p>
    </div>
  </div>
</div>

<p-dialog header="صور من كتاب درر الياقوت" [modal]="true" [(visible)]="openDialog"
  [style]="{'max-width': '90vw', 'width': 'auto'}">
  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 p-6 bg-white rounded-xl shadow-inner">


    <!-- Image ١ -->
    <a href="../../../assets/img/source-image-2.jpeg" target="_blank" rel="noopener noreferrer"
      class="group relative overflow-hidden rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl">
      <img src="../../../assets/img/source-image-2.jpeg" alt="Image 2"
        class="w-full h-64 object-cover transform transition-transform duration-500 group-hover:scale-110">
      <div class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300"></div>
      <div
        class="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300 bg-gradient-to-t from-black/70 to-transparent">
        <h3 class="text-white text-lg font-bold">انقر لفتح الصورة</h3>
      </div>
    </a>


    <!-- Image ٢ -->
    <a href="../../../assets/img/source-image-1.jpeg" target="_blank" rel="noopener noreferrer"
      class="group relative overflow-hidden rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl">
      <img src="../../../assets/img/source-image-1.jpeg" alt="Image 1"
        class="w-full h-64 object-cover transform transition-transform duration-500 group-hover:scale-110">
      <div class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300"></div>
      <div
        class="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300 bg-gradient-to-t from-black/70 to-transparent">
        <h3 class="text-white text-lg font-bold">انقر لفتح الصورة</h3>
      </div>
    </a>

    <!-- Image ٣ -->
    <a href="../../../assets/img/source-image-3.jpeg" target="_blank" rel="noopener noreferrer"
      class="group relative overflow-hidden rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl">
      <img src="../../../assets/img/source-image-3.jpeg" alt="Image 3"
        class="w-full h-64 object-cover transform transition-transform duration-500 group-hover:scale-110">
      <div class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300"></div>
      <div
        class="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300 bg-gradient-to-t from-black/70 to-transparent">
        <h3 class="text-white text-lg font-bold">انقر لفتح الصورة</h3>
      </div>
    </a>
  </div>
</p-dialog>
<app-footer></app-footer>